const id_master_itemtag = {
    "": "tag barang",
    add: "tambah tag barang",
    edit: "ubah tag barang",
    name: "nama tag barang",

    error: {
        create: "Gagal membuat tag barang.",
        delete: "Gagal menghapus tag barang.",
        edit: "Gagal mengubah tag barang.",
        name: "Nama tag barang tidak boleh kosong."
    },

    success: {
        create: "Berhasil membuat tag barang.",
        delete: "Berhasil menghapus tag barang.",
        edit: "Berhasil mengubah tag barang.",
    }
}

export default id_master_itemtag